export function getServiceName(arg: string) {
	switch (arg) {
		case 'S':
			return 'Water and Wastewater';
		case 'O':
			return 'Water';
		case 'W':
			return 'Wastewater';
		default:
			return '';
	}
}
